import AGENDA from './i18n/agenda.json';
import BRANCHES from './i18n/branches.json';
import CAROUSEL from './i18n/carousel.json';
import CATEGORIES from './i18n/categories.json';
import COMMON from './i18n/common.json';
import CONTACTS from './i18n/contacts.json';
import ERROR from './i18n/error.json';
import EXPERTISES from './i18n/expertises.json';
import FILTERS from './i18n/filters.json';
import FINANCIAL from './i18n/financial.json';
import FOOTER from './i18n/footer.json';
import GOUVERNANCE from './i18n/gouvernance.json';
import HEADER from './i18n/header.json';
import HOME from './i18n/home.json';
import ICON from './i18n/icon.json';
import INNOVATIONS from './i18n/innovations.json';
import MEDIA from './i18n/media.json';
import MEDIA_THEMATIC from './i18n/media-thematic.json';
import PRESS_AREA from './i18n/press-area.json';
import RGPD from './i18n/RGPD.json';
import SEARCH from './i18n/search.json';
import SHORTCUTS from './i18n/shortcuts.json';
import SOCIAL from './i18n/social.json';
import TERRITORIES from './i18n/territories.json';
import THEMATICS from './i18n/thematics.json';
import TYPES from './i18n/types.json';
import DATA_NOVA_MAP from './i18n/data-nova-map.json';
import PAGINATION from './i18n/pagination.json';
import PUBLICATION from './i18n/publication.json';
import HUB_ACTUS from './i18n/hub-actualites.json';

export {
  AGENDA,
  BRANCHES,
  CATEGORIES,
  CAROUSEL,
  COMMON,
  CONTACTS,
  ERROR,
  EXPERTISES,
  FILTERS,
  FINANCIAL,
  FOOTER,
  GOUVERNANCE,
  HEADER,
  HOME,
  ICON,
  INNOVATIONS,
  MEDIA,
  MEDIA_THEMATIC,
  PRESS_AREA,
  RGPD,
  SEARCH,
  SHORTCUTS,
  SOCIAL,
  TERRITORIES,
  THEMATICS,
  TYPES,
  DATA_NOVA_MAP,
  PAGINATION,
  PUBLICATION,
  HUB_ACTUS,
};

export default {
  ...AGENDA,
  ...BRANCHES,
  ...CATEGORIES,
  ...CAROUSEL,
  ...COMMON,
  ...CONTACTS,
  ...ERROR,
  ...EXPERTISES,
  ...FILTERS,
  ...FINANCIAL,
  ...FOOTER,
  ...GOUVERNANCE,
  ...HEADER,
  ...HOME,
  ...ICON,
  ...INNOVATIONS,
  ...MEDIA,
  ...MEDIA_THEMATIC,
  ...PRESS_AREA,
  ...RGPD,
  ...SEARCH,
  ...SHORTCUTS,
  ...SOCIAL,
  ...TERRITORIES,
  ...THEMATICS,
  ...TYPES,
  ...DATA_NOVA_MAP,
  ...PAGINATION,
  ...PUBLICATION,
  ...HUB_ACTUS,
};
